(() => {
  const installGlobalSplideTrackpadSupport = () => {
    if (typeof window.Splide === "undefined" || window.ReproSplideTrackpadReady)
      return;
    window.ReproSplideTrackpadReady = true;

    const originalMount = window.Splide.prototype.mount;
    window.Splide.prototype.mount = function (...args) {
      const mountedSplide = originalMount.apply(this, args);
      if (this.root) this.root.reproSplideInstance = this;
      return mountedSplide;
    };

    const lockedSliders = new WeakSet();
    document.addEventListener(
      "wheel",
      (event) => {
        const slider = event.target.closest?.(".splide.is-initialized");
        const splide = slider?.reproSplideInstance;
        if (!slider || !splide || lockedSliders.has(slider)) return;

        const horizontalDelta = event.deltaX;
        if (
          Math.abs(horizontalDelta) < 12 ||
          Math.abs(horizontalDelta) <= Math.abs(event.deltaY)
        )
          return;

        const destination =
          horizontalDelta > 0
            ? splide.Components.Controller.getNext()
            : splide.Components.Controller.getPrev();
        if (destination < 0) return;

        event.preventDefault();
        lockedSliders.add(slider);
        splide.go(horizontalDelta > 0 ? ">" : "<");
        window.setTimeout(() => lockedSliders.delete(slider), 400);
      },
      { passive: false },
    );
  };

  installGlobalSplideTrackpadSupport();

  const initCustomBanner = (scope = document) => {
    if (typeof window.Splide === "undefined") return;
    scope.querySelectorAll("[data-custom-banner-slider]").forEach((slider) => {
      if (slider.dataset.splideInitialized === "true") return;
      const slideCount = slider.querySelectorAll(".splide__slide").length;
      slider
        .querySelectorAll("[data-banner-deferred-slide]")
        .forEach((slide) => {
          slide.style.removeProperty("display");
        });
      const splide = new window.Splide(slider, {
        type: slideCount > 1 ? "fade" : "slide",
        rewind: slideCount > 1,
        perPage: 1,
        perMove: 1,
        speed: 700,
        arrows: false,
        pagination: slideCount > 1,
        drag: slideCount > 1,
        autoplay: slideCount > 1 && slider.dataset.autoplay === "true",
        interval: Number(slider.dataset.interval) || 5000,
        pauseOnHover: true,
        pauseOnFocus: true,
        keyboard: "focused",
      });
      splide.mount();

      let bannerHasLeftViewport = false;
      let bannerIsVisible = false;
      const bannerSection = slider.closest(".custom-banner");
      const replayFrames = {
        "zoom-out": [
          { opacity: 0, transform: "scale(1.2)" },
          { opacity: 1, transform: "scale(1)" },
        ],
        "fade-down": [
          { opacity: 0, transform: "translateY(-100px)" },
          { opacity: 1, transform: "translateY(0)" },
        ],
        "fade-right": [
          { opacity: 0, transform: "translateX(-100px)" },
          { opacity: 1, transform: "translateX(0)" },
        ],
        "fade-up": [
          { opacity: 0, transform: "translateY(100px)" },
          { opacity: 1, transform: "translateY(0)" },
        ],
      };

      const replayBannerSlide = (slide) => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
          return;
        if (!slide) return;

        slide.querySelectorAll("[data-aos]").forEach((element) => {
          const frames = replayFrames[element.dataset.aos];
          if (!frames) return;
          element.getAnimations().forEach((animation) => animation.cancel());
          element.animate(frames, {
            duration: Number(element.dataset.aosDuration) || 700,
            delay: Number(element.dataset.aosDelay) || 0,
            easing: "cubic-bezier(.25, .46, .45, .94)",
            fill: "backwards",
          });
        });
      };

      const replayActiveBanner = () => {
        replayBannerSlide(
          slider.querySelector(".custom-banner__slide.is-active.is-visible"),
        );
      };

      const bannerAnimationObserver = new IntersectionObserver(
        ([entry]) => {
          bannerIsVisible = entry.isIntersecting;
          if (!entry.isIntersecting) {
            bannerHasLeftViewport = true;
            return;
          }
          if (!bannerHasLeftViewport) return;

          bannerHasLeftViewport = false;
          replayActiveBanner();
        },
        { threshold: 0.15 },
      );

      if (bannerSection) bannerAnimationObserver.observe(bannerSection);
      splide.on("move", (newIndex, previousIndex, destinationIndex) => {
        if (!bannerIsVisible) return;
        const destinationSlide =
          splide.Components.Slides.getAt(destinationIndex) ||
          splide.Components.Slides.getAt(newIndex);
        replayBannerSlide(destinationSlide?.slide);

        const logicalSlide = splide.Components.Slides.getAt(newIndex);
        if (
          logicalSlide?.slide &&
          logicalSlide.slide !== destinationSlide?.slide
        ) {
          replayBannerSlide(logicalSlide.slide);
        }
      });
      slider.dataset.splideInitialized = "true";
      slider.customBannerSplide = splide;
      slider.customBannerAnimationObserver = bannerAnimationObserver;
    });
  };

  const initHelpMeChoose = (scope = document) => {
    if (typeof window.Splide === "undefined") return;

    scope.querySelectorAll("[data-help-me-choose-slider]").forEach((slider) => {
      if (slider.dataset.splideInitialized === "true") return;
      if (slider.dataset.sliderEnabled !== "true") return;

      const desktopPeek = slider.dataset.desktopPeek === "true";
      const desktopPerPage = Number(slider.dataset.desktopPerPage) || 3;

      const splide = new window.Splide(slider, {
        type: "slide",
        perPage: desktopPerPage,
        perMove: 1,
        gap: "24px",
        speed: 550,
        pagination: false,
        arrows: true,
        drag: true,
        keyboard: "global",
        omitEnd: !desktopPeek,
        padding: desktopPeek ? { right: "8%" } : 0,
        breakpoints: {
          989: { perPage: 2, gap: "20px", padding: 0, omitEnd: true },
          749: { perPage: 1, gap: "16px" },
        },
      });

      splide.mount();
      slider.dataset.splideInitialized = "true";
      slider.helpMeChooseSplide = splide;
    });
  };

  const initWhoWeHelp = (scope = document) => {
    if (typeof window.Splide === "undefined") return;

    scope.querySelectorAll("[data-who-we-help-slider]").forEach((slider) => {
      if (slider.dataset.splideInitialized === "true") return;

      const desktopPeek = slider.dataset.desktopPeek === "true";

      const splide = new window.Splide(slider, {
        type: "slide",
        perPage: 3,
        perMove: 1,
        gap: "24px",
        speed: 550,
        pagination: false,
        arrows: true,
        drag: true,
        keyboard: "global",
        omitEnd: !desktopPeek,
        padding: desktopPeek ? { right: "8%" } : 0,
        breakpoints: {
          989: { perPage: 2, gap: "20px", padding: 0, omitEnd: true },
          749: { perPage: 1, gap: "16px" },
        },
      });

      const desktopHover = window.matchMedia(
        "(min-width: 990px) and (hover: hover) and (pointer: fine)",
      );
      const slides = Array.from(slider.querySelectorAll(".who-we-help__slide"));

      const collapseCards = () => {
        slider.classList.remove("is-card-expanded");
        slides.forEach((slide) => slide.classList.remove("is-expanded"));
      };

      const expandCard = (slide) => {
        if (!desktopHover.matches || !slide.classList.contains("is-visible"))
          return;
        slides.forEach((item) =>
          item.classList.toggle("is-expanded", item === slide),
        );
        slider.classList.add("is-card-expanded");
      };

      slides.forEach((slide) => {
        slide.addEventListener("pointerenter", () => expandCard(slide));
        slide.addEventListener("focusin", () => expandCard(slide));
        slide.addEventListener("focusout", (event) => {
          if (!slide.contains(event.relatedTarget)) collapseCards();
        });
      });

      slider.addEventListener("pointerleave", collapseCards);
      desktopHover.addEventListener("change", collapseCards);
      splide.on("move drag resize", collapseCards);

      splide.mount();
      slider.dataset.splideInitialized = "true";
      slider.whoWeHelpSplide = splide;
    });
  };

  const initTrustedQuote = (scope = document) => {
    if (typeof window.Splide === "undefined") return;

    scope.querySelectorAll("[data-trusted-quote-slider]").forEach((slider) => {
      if (slider.dataset.splideInitialized === "true") return;

      const splide = new window.Splide(slider, {
        type: "slide",
        autoWidth: true,
        perMove: 1,
        gap: 0,
        speed: 650,
        pagination: true,
        arrows: false,
        drag: true,
        keyboard: "focused",
        omitEnd: true,
      });

      splide.mount();
      slider.dataset.splideInitialized = "true";
      slider.trustedQuoteSplide = splide;
    });
  };

  const initQuoteServices = (scope = document) => {
    if (typeof window.Splide === "undefined") return;

    scope.querySelectorAll("[data-quote-services-slider]").forEach((slider) => {
      if (slider.dataset.splideInitialized === "true") return;

      const splide = new window.Splide(slider, {
        type: "slide",
        perPage: 4,
        perMove: 1,
        gap: "24px",
        speed: 650,
        pagination: true,
        arrows: true,
        drag: true,
        keyboard: "focused",
        omitEnd: true,
        breakpoints: {
          1439: { perPage: 3 },
          989: {
            perPage: 1,
            fixedWidth: "238px",
            gap: "12px",
            arrows: false,
            padding: { left: "20px", right: "20px" },
          },
          389: {
            fixedWidth: "230px",
            padding: { left: "16px", right: "16px" },
          },
        },
      });

      splide.mount();
      slider.dataset.splideInitialized = "true";
      slider.quoteServicesSplide = splide;
    });
  };

  const initQuoteHowItWorks = (scope = document) => {
    if (typeof window.Splide === "undefined") return;

    scope
      .querySelectorAll("[data-quote-how-it-works-slider]")
      .forEach((slider) => {
        if (slider.dataset.splideInitialized === "true") return;

        const splide = new window.Splide(slider, {
          type: "slide",
          perPage: 4,
          perMove: 1,
          gap: "24px",
          speed: 650,
          pagination: false,
          arrows: false,
          drag: true,
          keyboard: "focused",
          omitEnd: true,
          breakpoints: {
            989: { perPage: 2, gap: "20px" },
            749: { perPage: 1, fixedWidth: "155px", gap: "20px" },
          },
        });

        splide.mount();
        slider.dataset.splideInitialized = "true";
        slider.quoteHowItWorksSplide = splide;
      });
  };

  const initYearbookFeatures = (scope = document) => {
    if (typeof window.Splide === "undefined") return;

    scope
      .querySelectorAll("[data-yearbook-features-slider]")
      .forEach((slider) => {
        if (slider.dataset.splideInitialized === "true") return;

        const slideCount = slider.querySelectorAll(".splide__slide").length;
        const splide = new window.Splide(slider, {
          type: "slide",
          perPage: 2,
          perMove: 1,
          gap: "24px",
          speed: 550,
          pagination: false,
          arrows: slideCount > 1,
          drag: slideCount > 1,
          keyboard: "focused",
          omitEnd: true,
          breakpoints: {
            989: {
              perPage: 1,
              gap: "18px",
            },
            749: {
              perPage: 1,
              gap: "14px",
            },
          },
        });

        splide.mount();
        slider.dataset.splideInitialized = "true";
        slider.yearbookFeaturesSplide = splide;
      });
  };

  const initShopBusinessCards = (scope = document) => {
    if (typeof window.Splide === "undefined") return;

    scope
      .querySelectorAll("[data-shop-business-cards-slider]")
      .forEach((slider) => {
        if (slider.dataset.splideInitialized === "true") return;

        const slideCount = slider.querySelectorAll(".splide__slide").length;
        const splide = new window.Splide(slider, {
          type: "slide",
          perPage: 1,
          perMove: 1,
          gap: "13px",
          padding: {
            right: "35%",
          },
          speed: 550,
          arrows: false,
          pagination: slideCount > 1,
          drag: slideCount > 1,
          keyboard: "focused",
          mediaQuery: "min",
          breakpoints: {
            750: {
              destroy: true,
            },
          },
        });

        splide.mount();
        slider.dataset.splideInitialized = "true";
        slider.shopBusinessCardsSplide = splide;
      });
  };

  const initRelatedProducts = (scope = document) => {
    if (typeof window.Splide === "undefined") return;

    scope
      .querySelectorAll("[data-related-products-slider]")
      .forEach((slider) => {
        if (slider.dataset.splideInitialized === "true") return;

        const slideCount = slider.querySelectorAll(".splide__slide").length;
        if (!slideCount) return;

        const splide = new window.Splide(slider, {
          type: "slide",
          fixedWidth: "min(255px, calc(100vw - 44px))",
          perMove: 1,
          gap: "12px",
          padding: { right: "20px" },
          speed: 550,
          arrows: false,
          pagination: slideCount > 1,
          drag: slideCount > 1,
          keyboard: "focused",
          mediaQuery: "min",
          breakpoints: {
            990: {
              destroy: true,
            },
          },
        });

        splide.mount();
        slider.dataset.splideInitialized = "true";
        slider.relatedProductsSplide = splide;
      });
  };

  const initCollectionProductShowcase = (scope = document) => {
    if (typeof window.Splide === "undefined") return;

    scope
      .querySelectorAll("[data-collection-products-slider]")
      .forEach((slider) => {
        if (slider.dataset.splideInitialized === "true") return;

        const row = slider.closest(".collection-product-showcase__row");
        const previousButton = row?.querySelector(
          "[data-collection-products-previous]",
        );
        const nextButton = row?.querySelector(
          "[data-collection-products-next]",
        );
        const slideCount = slider.querySelectorAll(".splide__slide").length;
        const showNextProduct = slideCount > 3;

        const splide = new window.Splide(slider, {
          type: "slide",
          perPage: 3,
          perMove: 1,
          gap: "20px",
          padding: showNextProduct ? { right: "10%" } : 0,
          speed: 550,
          arrows: false,
          pagination: false,
          drag: slideCount > 3,
          keyboard: "focused",
          omitEnd: true,
          trimSpace: "move",
          breakpoints: {
            1024: {
              perPage: 2,
              gap: "18px",
              padding: showNextProduct ? { right: "10%" } : 0,
            },
            749: {
              type: slideCount > 1 ? "loop" : "slide",
              perPage: slideCount > 1 ? 1.9 : 1,
              gap: "14px",
              pagination: true,
              drag: slideCount > 1,
              omitEnd: false,
              trimSpace: true,
              padding: 0,
            },
          },
        });

        const getLastPeekIndex = () => {
          if (window.matchMedia("(max-width: 749px)").matches) {
            return splide.Components.Controller.getEnd();
          }

          const visibleSlides = Math.floor(Number(splide.options.perPage) || 1);
          return Math.max(0, slideCount - visibleSlides);
        };

        const updateArrowState = () => {
          const isMobileLoop = window.matchMedia("(max-width: 749px)").matches;
          const lastPeekIndex = getLastPeekIndex();

          if (previousButton) {
            previousButton.disabled = !isMobileLoop && splide.index === 0;
          }
          if (nextButton) {
            nextButton.disabled =
              !isMobileLoop && splide.index >= lastPeekIndex;
          }
        };

        previousButton?.addEventListener("click", () => splide.go("<"));
        nextButton?.addEventListener("click", () => {
          if (window.matchMedia("(max-width: 749px)").matches) {
            splide.go(">");
            return;
          }

          const nextIndex = Math.min(splide.index + 1, getLastPeekIndex());
          if (nextIndex !== splide.index) splide.go(nextIndex);
        });
        splide.on("mounted moved resized updated", updateArrowState);
        splide.mount();

        slider.dataset.splideInitialized = "true";
        slider.collectionProductsSplide = splide;
        updateArrowState();
      });
  };

  const initProductFeatureOrbit = (scope = document) => {
    scope
      .querySelectorAll("[data-product-feature-orbit]")
      .forEach((section) => {
        if (section.dataset.orbitInitialized === "true") return;

        const reducedMotion = window.matchMedia(
          "(prefers-reduced-motion: reduce)",
        ).matches;
        const accordionButtons = [
          ...section.querySelectorAll("[data-orbit-accordion-button]"),
        ];
        let animationFrame = null;
        let currentProgress = 0;
        let targetProgress = 0;

        accordionButtons.forEach((button) => {
          button.addEventListener("click", () => {
            if (!window.matchMedia("(max-width: 989px)").matches) return;
            const willOpen = button.getAttribute("aria-expanded") !== "true";
            accordionButtons.forEach((item) =>
              item.setAttribute("aria-expanded", "false"),
            );
            button.setAttribute("aria-expanded", String(willOpen));
          });
        });

        const renderScrollProgress = () => {
          currentProgress += (targetProgress - currentProgress) * 0.14;

          if (Math.abs(targetProgress - currentProgress) < 0.001) {
            currentProgress = targetProgress;
          }

          const imageTravel = window.matchMedia("(max-width: 989px)").matches
            ? 90
            : 145;

          section.style.setProperty(
            "--orbit-image-offset",
            `${((1 - currentProgress) * imageTravel).toFixed(2)}%`,
          );

          if (currentProgress !== targetProgress) {
            animationFrame = window.requestAnimationFrame(renderScrollProgress);
          } else {
            animationFrame = null;
          }
        };

        const updateScrollProgress = () => {
          const bounds = section.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          const animationStart = viewportHeight * 0.5;
          const animationDistance = Math.max(bounds.height * 0.5, 1);

          targetProgress = Math.min(
            1,
            Math.max(0, (animationStart - bounds.top) / animationDistance),
          );

          if (animationFrame === null) {
            animationFrame = window.requestAnimationFrame(renderScrollProgress);
          }
        };

        const requestScrollUpdate = () => {
          updateScrollProgress();
        };

        const startDotMotion = () => {
          const path = section.querySelector(
            ".product-feature-orbit__ring-path",
          );

          if (!path || typeof path.getTotalLength !== "function") return;

          const pathLength = path.getTotalLength();

          section.querySelectorAll("[data-orbit-marker]").forEach((marker) => {
            const delay = Number.parseInt(marker.dataset.delay, 10) || 0;
            const startProgress =
              Number.parseFloat(marker.dataset.pathStart) || 0;
            const finalProgress =
              Number.parseFloat(marker.dataset.pathProgress) || 0;
            const duration = 1500;
            const initialPoint = path.getPointAtLength(
              pathLength * startProgress,
            );

            marker.setAttribute(
              "transform",
              `translate(${initialPoint.x} ${initialPoint.y})`,
            );

            window.setTimeout(() => {
              const startTime = window.performance.now();

              const moveMarker = (currentTime) => {
                const elapsed = Math.min(
                  1,
                  (currentTime - startTime) / duration,
                );
                const easedProgress = 1 - Math.pow(1 - elapsed, 2);
                const pathProgress =
                  startProgress +
                  (finalProgress - startProgress) * easedProgress;
                const point = path.getPointAtLength(pathLength * pathProgress);

                marker.setAttribute(
                  "transform",
                  `translate(${point.x} ${point.y})`,
                );

                if (elapsed < 1) {
                  window.requestAnimationFrame(moveMarker);
                }
              };

              window.requestAnimationFrame(moveMarker);
            }, delay);
          });
        };

        section.classList.add("is-animation-ready");

        if (reducedMotion) {
          section
            .querySelectorAll(".product-feature-orbit__marker")
            .forEach((marker) => {
              const finalPosition = marker.dataset.finalPosition;

              if (finalPosition) {
                marker.setAttribute("transform", `translate(${finalPosition})`);
              }
            });

          section.classList.add("is-in-view");
        } else {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                observer.disconnect();

                window.requestAnimationFrame(() => {
                  window.requestAnimationFrame(() => {
                    section.classList.add("is-in-view");
                    startDotMotion();
                    requestScrollUpdate();
                  });
                });
              });
            },
            {
              rootMargin: "0px 0px -8% 0px",
              threshold: 0.08,
            },
          );

          observer.observe(section);
          window.addEventListener("scroll", requestScrollUpdate, {
            passive: true,
          });
          window.addEventListener("resize", requestScrollUpdate);
          updateScrollProgress();

          section.orbitAnimationCleanup = () => {
            observer.disconnect();
            window.removeEventListener("scroll", requestScrollUpdate);
            window.removeEventListener("resize", requestScrollUpdate);

            if (animationFrame !== null) {
              window.cancelAnimationFrame(animationFrame);
            }
          };
        }

        section.dataset.orbitInitialized = "true";
      });
  };

  const initProductFaqGrid = (scope = document) => {
    scope.querySelectorAll("[data-product-faq-grid]").forEach((section) => {
      if (section.dataset.faqGridInitialized === "true") return;

      const buttons = [
        ...section.querySelectorAll("[data-product-faq-button]"),
      ];
      const hiddenItems = [
        ...section.querySelectorAll("[data-product-faq-item].is-mobile-hidden"),
      ];
      const loadMore = section.querySelector("[data-product-faq-load-more]");

      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          if (!window.matchMedia("(max-width: 749px)").matches) return;
          const willOpen = button.getAttribute("aria-expanded") !== "true";
          buttons.forEach((item) =>
            item.setAttribute("aria-expanded", "false"),
          );
          button.setAttribute("aria-expanded", String(willOpen));
        });
      });

      loadMore?.addEventListener("click", () => {
        const expanded = loadMore.getAttribute("aria-expanded") === "true";
        loadMore.setAttribute("aria-expanded", String(!expanded));
        hiddenItems.forEach((item) =>
          item.classList.toggle("is-mobile-revealed", !expanded),
        );
        loadMore.textContent = expanded ? "Load More" : "Load Less";
      });

      section.dataset.faqGridInitialized = "true";
    });
  };

  const initWhatWeDo = (scope = document) => {
    scope.querySelectorAll("[data-what-we-do]").forEach((section) => {
      if (section.dataset.whatWeDoInitialized === "true") return;

      const tabs = [...section.querySelectorAll("[data-what-we-do-tab]")];
      const panels = [...section.querySelectorAll("[data-what-we-do-panel]")];
      const panelScroller = section.querySelector("[data-what-we-do-scroller]");
      const scrollThumb = section.querySelector("[data-what-we-do-thumb]");

      const updatePanelScrollbar = () => {
        if (!panelScroller || !scrollThumb) return;
        const viewport = panelScroller.clientHeight;
        const content = panelScroller.scrollHeight;
        const track = scrollThumb.parentElement.clientHeight;
        const thumbHeight =
          content > viewport
            ? Math.max(42, (track * viewport) / content)
            : track;
        const maxScroll = Math.max(1, content - viewport);
        const maxOffset = Math.max(0, track - thumbHeight);
        scrollThumb.style.setProperty(
          "--scroll-thumb-height",
          `${thumbHeight}px`,
        );
        scrollThumb.style.setProperty(
          "--scroll-thumb-offset",
          `${(maxOffset * panelScroller.scrollTop) / maxScroll}px`,
        );
      };
      const activate = (index, moveFocus = false) => {
        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.classList.toggle("is-active", active);
          tab.setAttribute("aria-selected", String(active));
          tab.setAttribute("tabindex", active ? "0" : "-1");
          if (active && moveFocus) tab.focus();
        });

        panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.classList.toggle("is-active", active);
          panel.setAttribute("aria-hidden", String(!active));
          if (active) {
            const activeScroller = panel.closest(".what-we-do__panels");
            activeScroller?.scrollTo({
              top: panel.offsetTop - activeScroller.offsetTop,
              behavior: "smooth",
            });
          }
        });
        requestAnimationFrame(updatePanelScrollbar);
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => activate(index));
        tab.addEventListener("mouseenter", () => {
          if (window.matchMedia("(hover: hover) and (pointer: fine)").matches)
            activate(index);
        });
        tab.addEventListener("keydown", (event) => {
          if (!["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key))
            return;
          event.preventDefault();
          let next = index;
          if (event.key === "ArrowDown") next = (index + 1) % tabs.length;
          if (event.key === "ArrowUp")
            next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === "Home") next = 0;
          if (event.key === "End") next = tabs.length - 1;
          activate(next, true);
        });
      });

      activate(
        Math.max(
          0,
          tabs.findIndex((tab) => tab.classList.contains("is-active")),
        ),
      );
      panelScroller?.addEventListener("scroll", updatePanelScrollbar, {
        passive: true,
      });
      window.addEventListener("resize", updatePanelScrollbar);
      updatePanelScrollbar();
      section.dataset.whatWeDoInitialized = "true";
    });
  };

  const initOurWork = (scope = document) => {
    if (typeof window.Splide === "undefined") return;

    scope.querySelectorAll("[data-our-work]").forEach((section) => {
      if (section.dataset.ourWorkInitialized === "true") return;
      const tabs = [...section.querySelectorAll("[data-our-work-tab]")];
      const panels = [...section.querySelectorAll("[data-our-work-panel]")];

      panels.forEach((panel) => {
        const slider = panel.querySelector("[data-our-work-slider]");
        if (!slider || slider.dataset.splideInitialized === "true") return;
        const splide = new window.Splide(slider, {
          type: Number(slider.dataset.slideCount) > 1 ? "loop" : "slide",
          perPage: 1,
          perMove: 1,
          gap: "20px",
          speed: 600,
          pagination: false,
          arrows: Number(slider.dataset.slideCount) > 1,
          drag: Number(slider.dataset.slideCount) > 1,
          keyboard: "focused",
          breakpoints: {
            989: {
              pagination: Number(slider.dataset.slideCount) > 1,
              arrows: false,
            },
          },
        });
        splide.mount();
        slider.dataset.splideInitialized = "true";
        slider.ourWorkSplide = splide;
      });

      const activateTab = (index, moveFocus = false) => {
        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.classList.toggle("is-active", active);
          tab.setAttribute("aria-selected", String(active));
          tab.setAttribute("tabindex", active ? "0" : "-1");
          if (active && moveFocus) tab.focus();
        });
        panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.hidden = !active;
          panel.classList.toggle("is-active", active);
          if (active) {
            panel
              .querySelector("[data-our-work-slider]")
              ?.ourWorkSplide?.refresh();
            window.requestAnimationFrame(() => window.AOS?.refreshHard());
          }
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => activateTab(index));
        tab.addEventListener("keydown", (event) => {
          if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key))
            return;
          event.preventDefault();
          let next = index;
          if (event.key === "ArrowRight") next = (index + 1) % tabs.length;
          if (event.key === "ArrowLeft")
            next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === "Home") next = 0;
          if (event.key === "End") next = tabs.length - 1;
          activateTab(next, true);
        });
      });

      section.addEventListener("click", (event) => {
        const trigger = event.target.closest("[data-work-accordion]");
        if (!trigger) return;
        const item = trigger.closest(".our-work__accordion-item");
        const slide = trigger.closest(".our-work__project");
        const wasOpen = item.classList.contains("is-open");
        slide.querySelectorAll(".our-work__accordion-item").forEach((entry) => {
          entry.classList.remove("is-open");
          entry
            .querySelector("[data-work-accordion]")
            ?.setAttribute("aria-expanded", "false");
        });
        if (!wasOpen) {
          item.classList.add("is-open");
          trigger.setAttribute("aria-expanded", "true");
        }
      });

      if (window.matchMedia("(max-width: 989px)").matches) {
        section
          .querySelectorAll(".our-work__accordion-item")
          .forEach((item) => {
            item.classList.remove("is-open");
            item
              .querySelector("[data-work-accordion]")
              ?.setAttribute("aria-expanded", "false");
          });
      }

      activateTab(0);
      section.dataset.ourWorkInitialized = "true";
    });
  };

  const initHowItWorks = (scope = document) => {
    if (typeof window.Splide === "undefined") return;

    scope.querySelectorAll("[data-how-it-works-slider]").forEach((slider) => {
      if (slider.dataset.splideInitialized === "true") return;
      const stepCount = Number(slider.dataset.stepCount);
      const splide = new window.Splide(slider, {
        type: stepCount > 4 ? "slide" : "slide",
        perPage: 4,
        perMove: 1,
        gap: "36px",
        speed: 600,
        pagination: false,
        arrows: stepCount > 4,
        drag: stepCount > 4,
        keyboard: "focused",
        breakpoints: {
          989: {
            fixedWidth: "63%",
            gap: "12px",
            arrows: false,
            pagination: stepCount > 1,
            drag: stepCount > 1,
            focus: 0,
            trimSpace: false,
          },
        },
      });
      splide.mount();
      slider.dataset.splideInitialized = "true";
      slider.howItWorksSplide = splide;
    });
  };

  const initWhyRepro = (scope = document) => {
    if (typeof window.Splide === "undefined") return;

    scope.querySelectorAll("[data-why-repro-slider]").forEach((slider) => {
      if (slider.dataset.splideInitialized === "true") return;
      const statCount = Number(slider.dataset.statCount);
      const splide = new window.Splide(slider, {
        type: "slide",
        perPage: 4,
        perMove: 1,
        gap: 0,
        pagination: false,
        arrows: false,
        drag: false,
        breakpoints: {
          989: {
            perPage: 2,
            perMove: 2,
            pagination: statCount > 2,
            drag: statCount > 2,
            omitEnd: false,
          },
        },
      });
      splide.mount();
      slider.dataset.splideInitialized = "true";
      slider.whyReproSplide = splide;
    });
  };

  const initCustomFaq = (scope = document) => {
    scope.querySelectorAll("[data-custom-faq]").forEach((section) => {
      if (section.dataset.faqInitialized === "true") return;

      const reduceMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      ).matches;

      if (window.matchMedia("(max-width: 989px)").matches) {
        section
          .querySelectorAll(".custom-faq__item[open]")
          .forEach((item) => item.removeAttribute("open"));
      }

      const closeItem = (item) => {
        if (!item.open || item.dataset.animating === "true") return;
        if (reduceMotion) {
          item.removeAttribute("open");
          return;
        }

        const summary = item.querySelector("summary");
        const answer = item.querySelector(".custom-faq__answer");
        const startHeight = item.offsetHeight;
        const endHeight = summary.offsetHeight;
        item.dataset.animating = "true";
        const answerAnimation = answer?.animate(
          [
            { opacity: 1, transform: "translateY(0)" },
            { opacity: 0, transform: "translateY(-10px)" },
          ],
          { duration: 280, easing: "ease-in", fill: "forwards" },
        );
        const animation = item.animate(
          [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
          { duration: 440, easing: "cubic-bezier(.4, 0, .2, 1)" },
        );
        animation.onfinish = () => {
          item.removeAttribute("open");
          item.style.height = "";
          answerAnimation?.cancel();
          delete item.dataset.animating;
        };
      };

      const openItem = (item) => {
        if (item.open || item.dataset.animating === "true") return;
        const startHeight = item.offsetHeight;
        item.setAttribute("open", "");
        if (reduceMotion) return;

        const answer = item.querySelector(".custom-faq__answer");
        const endHeight = item.scrollHeight;
        item.dataset.animating = "true";
        item.style.height = `${startHeight}px`;
        const answerAnimation = answer?.animate(
          [
            { opacity: 0, transform: "translateY(-10px)" },
            { opacity: 1, transform: "translateY(0)" },
          ],
          {
            duration: 380,
            delay: 100,
            easing: "cubic-bezier(.22, 1, .36, 1)",
            fill: "both",
          },
        );
        const animation = item.animate(
          [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
          { duration: 520, easing: "cubic-bezier(.22, 1, .36, 1)" },
        );
        animation.onfinish = () => {
          item.style.height = "";
          answerAnimation?.cancel();
          delete item.dataset.animating;
        };
      };

      section.querySelectorAll(".custom-faq__item").forEach((item) => {
        item.querySelector("summary")?.addEventListener("click", (event) => {
          event.preventDefault();
          if (item.dataset.animating === "true") return;

          if (item.open) {
            closeItem(item);
            return;
          }

          section
            .querySelectorAll(".custom-faq__item[open]")
            .forEach((openItem) => {
              if (openItem !== item) closeItem(openItem);
            });
          openItem(item);
        });
      });

      section.dataset.faqInitialized = "true";
    });
  };

  const initCustomFooter = (scope = document) => {
    const footerItems = scope.querySelectorAll("[data-footer-accordion]");
    if (!footerItems.length) return;

    const footerBreakpoint = window.matchMedia("(max-width: 989px)");
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    const syncFooterAccordions = () => {
      footerItems.forEach((item) => {
        item.getAnimations().forEach((animation) => animation.cancel());
        item.style.height = "";
        item.style.overflow = "";
        delete item.dataset.animating;
        if (footerBreakpoint.matches) item.removeAttribute("open");
        else item.setAttribute("open", "");
      });
    };

    syncFooterAccordions();
    footerItems.forEach((item) => {
      if (item.dataset.footerAccordionInitialized === "true") return;
      const summary = item.querySelector("summary");
      const content = item.querySelector(".custom-footer__block-content");
      if (!summary || !content) return;

      summary.addEventListener("click", (event) => {
        if (!footerBreakpoint.matches) return;
        event.preventDefault();
        if (item.dataset.animating === "true") return;

        if (reduceMotion) {
          item.toggleAttribute("open");
          return;
        }

        const opening = !item.open;
        const startHeight = item.offsetHeight;
        if (opening) item.setAttribute("open", "");
        const endHeight = opening
          ? summary.offsetHeight + content.offsetHeight
          : summary.offsetHeight;

        item.dataset.animating = "true";
        item.style.overflow = "hidden";
        const contentAnimation = content.animate(
          opening
            ? [
                { opacity: 0, transform: "translateY(-8px)" },
                { opacity: 1, transform: "translateY(0)" },
              ]
            : [
                { opacity: 1, transform: "translateY(0)" },
                { opacity: 0, transform: "translateY(-8px)" },
              ],
          {
            duration: opening ? 320 : 220,
            easing: "cubic-bezier(.4, 0, .2, 1)",
            fill: "both",
          },
        );
        const heightAnimation = item.animate(
          [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
          {
            duration: opening ? 360 : 260,
            easing: "cubic-bezier(.4, 0, .2, 1)",
          },
        );

        heightAnimation.onfinish = () => {
          if (!opening) item.removeAttribute("open");
          item.style.height = "";
          item.style.overflow = "";
          contentAnimation.cancel();
          delete item.dataset.animating;
        };
      });
      item.dataset.footerAccordionInitialized = "true";
    });

    if (
      scope === document &&
      !document.documentElement.dataset.footerBreakpointBound
    ) {
      footerBreakpoint.addEventListener("change", syncFooterAccordions);
      document.documentElement.dataset.footerBreakpointBound = "true";
    }
  };

  const initTheme = (scope = document) => {
    initCustomBanner(scope);
    initHelpMeChoose(scope);
    initWhoWeHelp(scope);
    initTrustedQuote(scope);
    initQuoteServices(scope);
    initQuoteHowItWorks(scope);
    initYearbookFeatures(scope);
    initShopBusinessCards(scope);
    initRelatedProducts(scope);
    initCollectionProductShowcase(scope);
    initProductFeatureOrbit(scope);
    initProductFaqGrid(scope);
    initWhatWeDo(scope);
    initOurWork(scope);
    initHowItWorks(scope);
    initCustomFooter(scope);
    initWhyRepro(scope);
    initCustomFaq(scope);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initTheme());
  } else {
    initTheme();
  }

  document.addEventListener("shopify:section:load", (event) =>
    initTheme(event.target),
  );

  const relatedProductsObserver = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length > 0)) {
      initRelatedProducts();
      window.requestAnimationFrame(() => window.AOS?.refreshHard());
    }
  });

  relatedProductsObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  document.addEventListener("shopify:section:unload", (event) => {
    event.target
      .querySelectorAll("[data-custom-banner-slider]")
      .forEach((slider) => {
        slider.customBannerAnimationObserver?.disconnect();
        slider.customBannerSplide?.destroy(true);
      });
    event.target
      .querySelectorAll("[data-help-me-choose-slider]")
      .forEach((slider) => {
        slider.helpMeChooseSplide?.destroy(true);
      });
    event.target
      .querySelectorAll("[data-who-we-help-slider]")
      .forEach((slider) => {
        slider.whoWeHelpSplide?.destroy(true);
      });
    event.target
      .querySelectorAll("[data-trusted-quote-slider]")
      .forEach((slider) => {
        slider.trustedQuoteSplide?.destroy(true);
      });
    event.target
      .querySelectorAll("[data-quote-services-slider]")
      .forEach((slider) => {
        slider.quoteServicesSplide?.destroy(true);
      });
    event.target
      .querySelectorAll("[data-quote-how-it-works-slider]")
      .forEach((slider) => {
        slider.quoteHowItWorksSplide?.destroy(true);
      });
    event.target
      .querySelectorAll("[data-yearbook-features-slider]")
      .forEach((slider) => {
        slider.yearbookFeaturesSplide?.destroy(true);
      });
    event.target
      .querySelectorAll("[data-shop-business-cards-slider]")
      .forEach((slider) => {
        slider.shopBusinessCardsSplide?.destroy(true);
      });
    event.target
      .querySelectorAll("[data-related-products-slider]")
      .forEach((slider) => {
        slider.relatedProductsSplide?.destroy(true);
      });
    event.target
      .querySelectorAll("[data-collection-products-slider]")
      .forEach((slider) => {
        slider.collectionProductsSplide?.destroy(true);
      });
    event.target
      .querySelectorAll("[data-product-feature-orbit]")
      .forEach((section) => {
        section.orbitAnimationCleanup?.();
      });
    event.target
      .querySelectorAll("[data-our-work-slider]")
      .forEach((slider) => {
        slider.ourWorkSplide?.destroy(true);
      });
    event.target
      .querySelectorAll("[data-how-it-works-slider]")
      .forEach((slider) => {
        slider.howItWorksSplide?.destroy(true);
      });
    event.target
      .querySelectorAll("[data-why-repro-slider]")
      .forEach((slider) => {
        slider.whyReproSplide?.destroy(true);
      });
  });
})();
